import {
    BarDataReceivedHandler,
    ExternalMarketDataStrategy,
    TickDataReceivedHandler,
    RefDataReceivedHandler,
} from 'marketData/ExternalMarketDataStrategy';
import { BloombergMarketDataRequest } from 'marketData/MarketDataRequest';
import { GlueBloombergBridge } from 'app/glue/bloomberg/GlueBloombergBridge';

export class BloombergExternalMarketDataStrategy
    implements ExternalMarketDataStrategy
{
    public constructor(private glueBridge: GlueBloombergBridge) {}

    public subscribe(request: BloombergMarketDataRequest): void {
        this.glueBridge.subscribe(request);
    }

    public unsubscribe(request: BloombergMarketDataRequest): void {
        this.glueBridge.unsubscribe(request);
    }

    public onMarketBarDataReceived(handler: BarDataReceivedHandler) {
        this.glueBridge.subscribeMarketBarDataReceived(handler);
    }

    public onRefDataReceived(handler: RefDataReceivedHandler) {
        this.glueBridge.subscribeRefDataReceived(handler);
    }

    public onMarketTickDataReceived(handler: TickDataReceivedHandler) {
        this.glueBridge.subscribeMarketTickDataReceived(handler);
    }
}
